<div fxLayout="row nowrap" fxLayoutGap="8px" fxLayoutAlign="center center">
  <button fxLayoutAlign="flex-start flex-start" mat-button class="account-btn" id="login-button"
     [matMenuTriggerFor]="logoutmenu" #logoutMenuTrigger="matMenuTrigger"
    cdkOverlayOrigin #overlayOrigin="cdkOverlayOrigin" (click)="onAccountClick()">
    <div [ngClass]="{ 'no-company-info': true }">
      <span class="person-container">
        <div class="badge" *ngIf="(username | async) === 'Mon compte'"></div>
        <div
          class="global-icon"
          fxFlex="24px"
          style="height: 24px;width: 24px;"
          [ngStyle]="{
            'mask-image': 'url(assets/icons/person.svg)',
            '-webkit-mask-image': 'url(assets/icons/person.svg)',
            'margin-top':isConnected?'5px':''
          }"
          alt="account"
        ></div>
      </span>
      <span class="hide-in-small-screens">{{ username | async }}</span>
      <div
        class="global-icon"
        *ngIf="isConnected"
        style="margin-left:4px;mask-image: url('assets/icons/arrow-dropdown.svg'); -webkit-mask-image: url('assets/icons/arrow-dropdown.svg'); width: 10px; height: 10px;"  
        [ngStyle]="{'margin-top':companyNumber?'.5rem':'1.1rem'}"
        ></div>
    </div>

  </button>

  <!--  -->
  <mat-menu #logoutmenu="matMenu" >
    <app-logout-drop-down-menu></app-logout-drop-down-menu>
  </mat-menu>
  <!---->



  <button
    mat-icon-button
    class="favorites-btn"
    style="background-color: transparent"
   [routerLink]="!!(totalDevisItemsCount)? ['/checkout'] : null"
    [disabled]="!!!(totalDevisItemsCount)"
  >
    <img
      *ngIf="!totalDevisItemsCount"
      src="assets/icons/Quotation_icon_offline.svg"
      alt="favorites"
      style="width: 24px; height: 24px;"
    />

    <div
      *ngIf="totalDevisItemsCount"
      class="global-icon"
      style="width: 24px; height: 24px;"
      [ngStyle]="{
        'mask-image': 'url(assets/icons/file_copy.svg)',
        '-webkit-mask-image': 'url(assets/icons/file_copy.svg)'
      }"
      alt="favorites"
    ></div>
  </button>

  <button
    mat-icon-button
    class="cart-btn"
    style="background-color: transparent"
    [routerLink]="!!(totalCartItemsCount | async)? ['/checkout'] : null"
    [disabled]="!!!(totalCartItemsCount | async)"
    [routerLink]="!!(totalCartItemsCount | async) ? ['/checkout'] : null"
    [matBadge]="(totalCartItemsCount | async)"
    [matBadgeHidden]="(totalCartItemsCount | async ) === 0  "
  >
    <img
      *ngIf="!(totalCartItemsCount | async)"
      style="cursor: pointer"
      (click)="goToCartCheckout()"
      (keydown.enter)="goToCartCheckout()"
      src="assets/icons/shopping_cart.svg"
      alt="cart"
    />

    <div
      *ngIf="totalCartItemsCount | async"
      class="global-icon"
      style="width: 24px; height: 24px; cursor: pointer;"
      (click)="goToCartCheckout()"
      (keydown.enter)="goToCartCheckout()"
      [ngStyle]="{
        'mask-image': 'url(assets/icons/shopping_cart-red.svg)',
        '-webkit-mask-image': 'url(assets/icons/shopping_cart-red.svg)'
      }"
      role="button"
      tabindex="0"
      aria-label="cart"
    >
    </div>
  </button>
  <span class="price" *ngIf="total | async" fxHide.lt-md
    >{{ total | async | number: "1.2-2" }} €</span
  >
</div>

<ng-template
  cdkConnectedOverlay
  [cdkConnectedOverlayOrigin]="overlayOrigin"
  [cdkConnectedOverlayOpen]="overlayOpened"
  [cdkConnectedOverlayGrowAfterOpen]="true"
  [cdkConnectedOverlayHasBackdrop]="true"
  (backdropClick)="closeOverlay()"
  (detach)="closeOverlay()"
>
  <ng-container [ngSwitch]="openedPane">
    <app-login
      *ngSwitchCase="'login'"
      (goToRequestPasswordReset)="openedPane = 'request-password-reset'"
      (goToSignup)="openedPane = 'signup'"
      (loginSuccess)="closeOverlay()"
    ></app-login>

    <app-signup
      *ngSwitchCase="'signup'"
      (goToLogin)="openedPane = 'login'"
      (closeOverlay)="closeOverlay()"
    ></app-signup>

    <app-request-password-reset
      *ngSwitchCase="'request-password-reset'"
      (closeOverlay)="closeOverlay()"
    ></app-request-password-reset>
  </ng-container>
</ng-template>
